import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueuesIssueViewEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const queuesIssueViewEntryPoint: EntryPoint<QueuesIssueViewEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<QueuesIssueViewEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-queues-issue-view", jiraSpaEntry: "async-servicedesk-queues-issue-view-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
